import { useQuery } from "@tanstack/react-query";
import { checkinApi } from "@bw/shared/api";
import type { BookingPassState } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Whether each of my bookings at a facility can show a check-in QR now
 * (GET /checkin/bookings/pass-states). A booking that is checked in, over or
 * cancelled carries the same refusal code the pass endpoint would return, so
 * the screen shows the reason instead of a "Show code" that would fail.
 */
export function useBookingPassStates(facilityId: string | undefined) {
  return useQuery<BookingPassState[]>({
    queryKey: queryKeys.booking.passStates(facilityId ?? ""),
    queryFn: () => checkinApi.listBookingPassStates(facilityId as string),
    enabled: Boolean(facilityId),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
